import React from 'react';
import './ImageStyleSheet.css';

function uml2() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/umass2.jpeg" className='img-view'/>
        </div>
    )
}

export default uml2
